import React, { FC } from 'react';
import { Theme, Modal, Paper, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ModalProps } from '@mui/material/Modal';
import { ButtonProps } from '@mui/material/Button';
import { makeStyles } from '@mui/styles';

type ModalWithoutChildrenProps = Omit<ModalProps, 'children'>;

interface CheckAccountNumberModalProps {
    modalProps?: ModalWithoutChildrenProps;
    buttonProps?: ButtonProps;
}

const useStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            width: '584px',
            padding: '56px',
            height: '250px',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            top: 'calc(50% - 181px)',
            left: 'calc(50% - 348px)',

            borderRadius: '10px',
            border: '2px solid #009ADE',
        },

        header: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        body: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '20px 0',
        },
        footer: {
            display: 'flex',
            justifyContent: 'center',
        },
        okButton: {
            padding: '0 20',
        },
    };
});

export const CheckAccountNumberModal: FC<CheckAccountNumberModalProps> = ({
    modalProps,
    buttonProps,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Modal
            aria-labelledby='close-warning-title'
            aria-describedby='close-warning-description'
            open={false}
            {...modalProps}
        >
            <Paper className={classes.root}>
                <div className={classes.header}>
                    <Typography variant='h3'>{t('Not Found')}</Typography>
                </div>
                <div className={classes.body}>
                    <Typography variant='h4' style={{ fontWeight: 'normal' }}>
                        {t('Please check account')}
                    </Typography>
                </div>

                <div className={classes.footer}>
                    <Button
                        className={classes.okButton}
                        variant='primary'
                        {...buttonProps}
                    >
                        <Typography variant='button'>OK</Typography>
                    </Button>
                </div>
            </Paper>
        </Modal>
    );
};
